import { AngledMarquee } from "@/components/layout/AngledMarquee";

/**
 * Angled scrolling marquee that sits ~15px directly beneath the hero section.
 * No band: the text sits on the page background and fades at both ends —
 * black text in light mode, white text in dark mode (text-foreground) — so it
 * blends into the surrounding background with no visible transition.
 * High z-index so the angled text always renders ABOVE the hero layer (never
 * clipped by the hero's diagonal). Editable in-place by admins (text/link/speed).
 */
export const HeroMarquee = () => (
  <AngledMarquee
    textField="hero_marquee_text"
    enabledField="hero_marquee_enabled"
    linkField="hero_marquee_link_url"
    targetField="hero_marquee_link_target"
    durationField="hero_marquee_duration"
    outerClassName="relative z-[30] -mt-[60px] h-[130px] overflow-hidden bg-transparent"
    textClassName="text-foreground"
    textMarginTop={47}
    editLabel="Edit banner"
    testIds={{
      container: "hero-marquee",
      input: "hero-marquee-input",
      linkInput: "hero-marquee-link-input",
      target: "hero-marquee-target",
      speed: "hero-marquee-speed",
      save: "hero-marquee-save",
      cancel: "hero-marquee-cancel",
      edit: "hero-marquee-edit",
      link: "hero-marquee-link",
    }}
  />
);
